import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/loader";
import {
  addCoachWorkshopData,
  createCoachWorkshopSpeakerImageData,
} from "../../../redux/features/coach/actions/authAction";
import { coachPaths } from "../../../routes/coach";
import CoachMenuLayout from "../../../layouts/CoachMenuLayout";
import { toUTCParts } from "../../../utils/pip";
import SavedAs from "../../../components/Modals/common/reserve-your-spot/SavedAs";

const CoachAddWorkshopDetails = () => {
  const user = { name: "WorkShop", role: "coach" };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname, state } = useLocation();
  const { isLoading } = useSelector((state) => state.coach.auth);
  const [status, setSatus] = useState("Draft");
  const [isSavedAsModal, setIsSavedAsModal] = useState(false);

  const [faqImage, setFaqImage] = useState("");
  const [speakerImages, setSpeakerImages] = useState([""]);
  const [speakerDetails, setSpeakerDetails] = useState([
    {
      heading: "Meet Nellie Padilla",
      body: "Founder Coach | Startup Strategist | Growth Guide",
    },
  ]);

  const [headerFirstImage, setHeaderFirstImage] = useState("");
  const [headerSecondImage, setHeaderSecondImage] = useState("");

  const [templateData, setTemplateData] = useState({
    section: {
      language: "English",
      location: "Ebene, Mauritius",
    },
    section1: {
      heading: "The Authority Blueprint: BUILD,POSITION,GROW",
      body: "Everyone wants to grow. Few know how to own what makes them stand out. In this interactive NUVIO workshop, we’ll help you move from freelancer mode to expert mindset. You’ll learn how to define your niche, craft your professional identity, and build visibility strategies that open real opportunities without shouting for attention.",
    },
    section2: {
      heading: "You’ll Get the Most Out of This If ?",
      title:
        "This workshop is built for professionals who are ready to stop waiting and start positioning themselves for growth.",
      description:
        "You’re ready to move from “doing” to “leading. You’ve built skills, now you want to be recognized for them. You’re ready to step up as a specialist, not just a service provider. You know you have value but struggle to express it clearly. you want to communicate what makes you different in a way that feels confident, not forced. You want clarity on your niche and your next step. You’re tired of trying to be everywhere and do everything — and you’re ready to focus on what truly fits your strengths and ambitions. You want to be seen  without “selling yourself. You believe in authentic visibility and want to learn how to build presence and trust naturally through your story, expertise, and impact. You’re ready to take action  not just notes. You learn best by doing. You’re looking for a workshop that doesn’t just inspire, but gives you tangible steps to apply right away.",
      body1:
        "A 75-minute guided session led by an expert coach, packed with insights, clarity exercises for entreprenurs.",
      body2:
        "Downloaded workbook and guided templates to help you apply what you learn with space to define your offer.",
      body3:
        "Interactive Q&A and optional replay access so you can ask questions, get unstuck and revisit key takeaways.",
    },
    section3: {
      heading: "Meet Nellie Padilla",
      body: "Founder Coach | Startup Strategist | Growth Guide",
      description:
        "Helping early-stage entrepreneurs turn ideas into launch-ready businesses with clarity, structure, and confidence. Nellie partners with solopreneurs and small teams to bring their ideas to life through strategic coaching, mindset support, and real-world launch tools.",
    },
    section4: {
      heading: "What You’ll Learn",
      body: "This session is designed to give you more than just ideas it delivers structure, clarity, and the tools to launch with purpose.",
      subHeading1: "Clarify Your Idea",
      subHeading2: "Build Your Launch Plan",
      subHeading3: "Define Your Offer",
      subHeading4: "Gain Confidence",
      subBody1:
        "Refine your business concept into something clear, focused, and ready to build on.",
      subBody2:
        "Map out the exact steps to launch-without overcomplicating the process.",
      subBody3:
        "Craft a simple, strategic offer that aligns with your audience and goals.",
      subBody4:
        "Walk away with clarity, momentum, and tools you can put into action right away.",
    },
    section5: {
      heading: "Workshop Details at a Glance",
      body: "Here’s everything you need to know to show up and get the most out of the session.",
      date: "",
      time: "",
      duration: "75 minutes",
      platform: "In-person, interactive 1-day workshop",
      link: "10000",
      access: "1 month free membership on NUVIO",
      body1:
        "A notebook or digital notes Your business idea or early stage plan Openness to learn, claify and take action",
    },
    section6: {
      faqs: [
        {
          question: "Why join a NUVIO workshop?",
          answer:
            "NUVIO workshops are designed to help you unlock creativity, develop skills, and gain practical strategies you can apply immediately. They offer hands-on learning, expert guidance, and opportunities to network with like-minded professionals.",
        },
        {
          question: "Who leads the workshops?",
          answer:
            "Our workshops are led by experienced coaches and industry professionals with proven expertise in innovation, freelancing, creative skills, and business development.",
        },
        {
          question: "Can I apply what I learn right away?",
          answer:
            "Yes! Each workshop is structured to provide actionable insights and exercises so you can implement your new skills and ideas immediately in your projects or freelance work.",
        },
        {
          question: "Do I get long-term value from a single workshop?",
          answer:
            "Absolutely. Beyond immediate takeaways, workshops provide frameworks, strategies, and connections that continue to benefit your career or freelance journey long after the session ends.",
        },
        {
          question: "Will it help my freelance or project work?",
          answer:
            "Yes. Workshops are tailored to help you refine your ideas, develop your skills, and gain the confidence and tools needed to grow your freelance business or succeed in your projects.",
        },
      ],
    },
  });

  useEffect(() => {
    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0]; // YYYY-MM-DD
    const formattedTime = now.toTimeString().split(":").slice(0, 2).join(":"); // HH:MM
    setTemplateData((prev) => ({
      ...prev,
      section5: {
        ...prev.section5,
        date: formattedDate,
        time: formattedTime,
      },
    }));
  }, []);

  const handleChangeValue = (e, field, data) => {
    // let data = field == "section5" && data == "date" ?
    if (field == "section5" && data == "date") {
      setTemplateData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [data]: e,
        },
      }));
    } else if (field == "section5" && data == "time") {
      setTemplateData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [data]: e,
        },
      }));
    } else {
      setTemplateData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [data]: e.target.innerText,
        },
      }));
    }
  };

  const handleAddFaq = () => {
    setTemplateData((prevData) => ({
      ...prevData,
      section6: {
        ...prevData.section6,
        faqs: [
          ...prevData.section6.faqs,
          { question: "Enter Question", answer: "Enter Answer" },
        ],
      },
    }));
  };

  const handleDeleteFaq = (index) => {
    setTemplateData((prevData) => ({
      ...prevData,
      section6: {
        ...prevData.section6,
        faqs: prevData.section6.faqs.filter((_, i) => i !== index),
      },
    }));
  };

  const handleSubmitForm = () => {
    const hasEmptyValue = Object.entries(templateData).some(
      ([key, section]) => {
        if (key === "section6") {
          return section.faqs.some(
            (faq) => faq.question.trim() === "" || faq.answer.trim() === ""
          );
        } else {
          return Object.values(section).some(
            (value) => typeof value === "string" && value.trim() === ""
          );
        }
      }
    );
    if (hasEmptyValue) {
      toast.error("Please fill out all fields before submitting.");
      return;
    } else {
      if (headerFirstImage != "" && headerSecondImage != "") {
        if (speakerImages?.length != 0) {
          if (
            state?.data?.speakerType != "Single" &&
            speakerImages?.filter((img) => img && img !== "").length < 2
          ) {
            toast.error("Please add at least 2 speakers and it's images");
            return;
          } else if (
            speakerImages?.filter((img) => img && img !== "").length < 1
          ) {
            toast.error("Please select the image of the speaker");
            return;
          } else if (faqImage == "") {
            toast.error("Please select the image of the faq");
            return;
          }

          return setIsSavedAsModal(true);
        } else {
          toast.error("Please Select the sepeker Image");
        }
      } else {
        toast.error("Please select the header image");
      }
    }
  };

  const handleFinalSubmit = () => {
    let data = {};

    const { date, time } = templateData.section5;
    if (!date || !time) return;

    // ✅ Get all UTC values at once
    const { utcDateTime, utcDate, utcTime } = toUTCParts(date, time);

    data = {
      section_1: {
        title: templateData?.section1?.heading,
        description: templateData?.section1?.body,
      },
      section_2: {
        title: templateData?.section2?.heading,
        subtitle: templateData?.section2?.title,
        description: templateData?.section2?.description,
      },
      section_3: {
        title: templateData?.section4?.heading,
        description: templateData?.section4?.body,
        cards: [
          {
            title: templateData?.section4?.subHeading1,
            description: templateData?.section4?.subBody1,
          },
          {
            title: templateData?.section4?.subHeading2,
            description: templateData?.section4?.subBody2,
          },
          {
            title: templateData?.section4?.subHeading3,
            description: templateData?.section4?.subBody3,
          },
          {
            title: templateData?.section4?.subHeading4,
            description: templateData?.section4?.subBody4,
          },
        ],
      },
      section_4: {
        title: templateData?.section5?.heading,
        description: templateData?.section5?.body,
        cards: [
          {
            title: utcDate,
            text_1: utcTime,
            text_2: templateData?.section5?.duration,
          },
          {
            title: templateData?.section5?.platform,
            text_1: templateData?.section5?.link,
            text_2: templateData?.section5?.access,
          },
          {
            title: templateData?.section5?.body1,
          },
        ],
      },
      section_5: templateData?.section6?.faqs,
      schedule_date: utcDateTime,
      location: templateData?.section?.location,
      language: templateData?.section?.language,
      hours: templateData?.section5?.duration,
      status: status,
    };
    const callback = (response) => {
      const callback1 = (response) => {
        navigate(coachPaths?.Event);
      };
      const workshopId = response?.data?.workshop?.workshop_id;
      let speakerData = [];
      if (state?.data?.speakerType !== "Single") {
        speakerData =
          speakerDetails?.map((item) => ({
            workshop_id: workshopId,
            name: item?.heading,
            role: item?.body,
          })) || [];
      } else {
        speakerData = [
          {
            workshop_id: workshopId,
            name: templateData?.section3?.heading,
            role: templateData?.section3?.body,
            sub_role: templateData?.section3?.description,
          },
        ];
      }
      const formData = new FormData();
      speakerImages?.forEach((item) => formData.append("file", item));
      formData.append("speakers", JSON.stringify(speakerData));
      formData.append("image1", headerFirstImage);
      formData.append("image2", headerSecondImage);
      formData.append("faqimage", faqImage);
      dispatch(
        createCoachWorkshopSpeakerImageData({
          payload: formData,
          callback: callback1,
        })
      );
    };
    dispatch(addCoachWorkshopData({ payload: data, callback }));
  };

  const handleSpeakerImageChange = (e) => {
    let img = [];
    img.push(e.target.files[0]);
    setSpeakerImages(img);
  };

  const handleAddSpeaker = () => {
    const newSpeaker = {
      heading: "Meet Nellie Padilla",
      body: "Founder Coach | Startup Strategist | Growth Guide",
    };
    setSpeakerDetails((prev) => [...prev, newSpeaker]);
    setSpeakerImages((prev) => [...prev, ""]);
  };

  const handleRemoveSpeaker = (index) => {
    setSpeakerDetails((prev) => prev?.filter((_, i) => i !== index));
    setSpeakerImages((prev) => prev?.filter((_, i) => i !== index));
  };

  const handleImageManage = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;
    setSpeakerImages((prev) => {
      const updated = [...prev];
      updated[index] = file;
      return updated;
    });
  };

  const handleChangeSpeakerData = (index, field, value) => {
    setSpeakerDetails((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const handleHeaderFirstImage = (e) => {
    setHeaderFirstImage(e.target.files[0]);
  };

  const handleHeaderSecondImage = (e) => {
    setHeaderSecondImage(e.target.files[0]);
  };

  const handleFaqImage = (e) => {
    setFaqImage(e.target.files[0]);
  };

  const handleFaqChange = (index, field, value) => {
    setTemplateData((prevData) => ({
      ...prevData,
      section6: {
        ...prevData.section6,
        faqs: prevData.section6.faqs.map((faq, i) =>
          i === index ? { ...faq, [field]: value } : faq
        ),
      },
    }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <CoachMenuLayout>
      <section class="ct_workshop_banner_detail ct_px_40 mt-5">
        <div class="container-fluid">
          <div class="row align-items-center ct_mb_100 pb-5">
            <div class="col-lg-7 mb-4 mb-lg-0">
              <div class="ps-lg-5">
                <h2
                  class="ct_fs_50 mb-3 ct_first_line_color ct_orange_text"
                  style={{ maxWidth: "681px" }}
                  contentEditable="true"
                  onBlur={(e) => handleChangeValue(e, "section1", "heading")}
                >
                  {templateData?.section1?.heading ?? ""}
                </h2>
                <p
                  class="mb-0 ct_fs_20"
                  style={{ maxWidth: "681px" }}
                  contentEditable="true"
                  onBlur={(e) => handleChangeValue(e, "section1", "body")}
                >
                  {templateData?.section1?.body ?? ""}
                </p>
                <div class="mt-4">
                  <a class="ct_yellow_btn px-5 ct_fit_content">
                    Reserve Your Spot
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-5 mb-4 mb-lg-0">
              <div className="position-relative ct_Authority_overlay_img_main">
                <label
                  class="ct_workshop_right_img w-100"
                  style={{ maxWidth: "340px" }}
                >
                  <input
                    className="d-none"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleHeaderFirstImage(e)}
                  />
                  <img
                    src={
                      headerFirstImage != ""
                        ? URL.createObjectURL(headerFirstImage) ??
                          "/assets/img/Authority_img_111_new.png"
                        : "/assets/img/Authority_img_111_new.png"
                    }
                    alt=""
                    className="ct_img_h_458"
                  />
                </label>
                <label class="ct_workshop_right_img">
                  <input
                    className="d-none"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleHeaderSecondImage(e)}
                  />
                  <img
                    src={
                      headerSecondImage != ""
                        ? URL.createObjectURL(headerSecondImage) ??
                          "/assets/img/Authority_img_112_new.png"
                        : "/assets/img/Authority_img_112_new.png"
                    }
                    alt=""
                    className="ct_img_h_328"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="d-lg-flex  align-items-center justify-content-around gap-3 mt-5 pb-3 ct_mt_3_1326 ct_grid_2_991_new pt-5">
            <label className="mb-0 d-flex align-items-center gap-1  ct_text_op_8 ct_fs_24 ct_outline_blue_5 ct_ms_minus_55">
              <input
                type="date"
                className="border-0 form-control px-0"
                min={new Date().toISOString().split("T")[0]}
                value={templateData?.section5?.date}
                onChange={(e) =>
                  handleChangeValue(e.target.value, "section5", "date")
                }
              />
              <input
                type="time"
                className="border-0 form-control"
                value={templateData?.section5?.time}
                onChange={(e) =>
                  handleChangeValue(e.target.value, "section5", "time")
                }
              />
            </label>
            <div
              class="ct_text_op_8 ct_fs_24  d-flex align-items-start gap-4 ct_para_scroll ct_custom_scroll"
              style={{ maxWidth: "250px", maxHeight: "50px" }}
              contentEditable="true"
              onBlur={(e) => handleChangeValue(e, "section", "location")}
            >
              <img
                src="/assets/img/location_icon_big_new.png"
                className="ct_icon_30"
              />{" "}
              <span className="mt-1">
                {" "}
                {templateData?.section?.location ?? ""}
              </span>
            </div>
            <div
              class="ct_text_op_8 ct_fs_24  d-flex align-items-center gap-4 ct_para_scroll ct_custom_scroll"
              style={{ maxWidth: "250px", maxHeight: "50px" }}
              contentEditable="true"
              onBlur={(e) => handleChangeValue(e, "section", "language")}
            >
              <img src="/assets/img/globe_icon.png" className="ct_icon_30" />{" "}
              {templateData?.section?.language ?? ""}
            </div>
            <div
              class="ct_text_op_8 ct_fs_24   d-flex align-items-center gap-4 ct_para_scroll ct_custom_scroll"
              style={{ maxWidth: "250px", maxHeight: "50px" }}
              contentEditable="true"
              onBlur={(e) => handleChangeValue(e, "section5", "duration")}
            >
              <img
                src="/assets/img/clock_new_icxon_22.png"
                className="ct_icon_30"
              />
              {templateData?.section5?.duration ?? ""}
            </div>
          </div>
        </div>
      </section>

      <section className="ct_pt_127_pb_97 ct_px_40 ct_light_sky_blue_bg">
        <div className="row align-items-center">
          <div className="col-xxl-5 col-xl-5 col-md-6 mb-4 mb-xl-0">
            <div>
              <img src="../assets/img/img_5480.png" className="ct_img_h_531" />
            </div>
          </div>
          <div className="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 ps-md-5">
            <h4
              className="ct_fs_32 ct_darksky_blue_text mb-2"
              contentEditable="true"
              onBlur={(e) => handleChangeValue(e, "section2", "heading")}
            >
              {templateData?.section2?.heading ?? ""}
            </h4>
            <p
              className="ct_orange_text mb-4 ct_fs_20"
              style={{ maxWidth: "849px" }}
              contentEditable="true"
              onBlur={(e) => handleChangeValue(e, "section2", "title")}
            >
              {templateData?.section2?.title ?? ""}
            </p>
            <ul>
              <li
                contentEditable="true"
                onBlur={(e) => handleChangeValue(e, "section2", "description")}
              >
                <p className="mb-0 ct_fs_20" style={{ maxWidth: "770px" }}>
                  {templateData?.section2?.description ?? ""}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {state?.data?.speakerType != "Multiple" ? (
        <section
          class="ct_coach_created_bg mt-0 ct_py_100"
          style={{ backgroundColor: "#ffb80533" }}
        >
          <div class="container">
            <div class="row">
              <div class="col-lg-4  mb-4 mb-lg-0">
                <label class="ct_learn_img d-block">
                  <input
                    className="d-none"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleSpeakerImageChange(e)}
                  />
                  <img
                    src={
                      speakerImages?.length != 0
                        ? speakerImages[0] != ""
                          ? URL.createObjectURL(speakerImages[0])
                          : "/assets/img/meet_nellie_img.png"
                        : "/assets/img/meet_nellie_img.png"
                    }
                    alt=""
                    style={{ height: "400px" }}
                  />
                </label>
              </div>
              <div class="col-lg-8 mb-4 mb-lg-0 ps-lg-5">
                <div class="d-flex align-items-end gap-3 ct_flex_col_575">
                  <div>
                    <h4
                      class="ct_fs_28 ct_orange_text mb-4"
                      contentEditable="true"
                      onBlur={(e) =>
                        handleChangeValue(e, "section3", "heading")
                      }
                    >
                      {templateData?.section3?.heading ?? ""}
                    </h4>
                    <p
                      class="ct_fs_22 mb-0"
                      contentEditable="true"
                      onBlur={(e) => handleChangeValue(e, "section3", "body")}
                    >
                      {templateData?.section3?.body ?? ""}
                    </p>
                    <div class="mt-4">
                      <p
                        class="ct_fs_20 mb-3"
                        style={{ maxWidth: "545px" }}
                        contentEditable="true"
                        onBlur={(e) =>
                          handleChangeValue(e, "section3", "description")
                        }
                      >
                        {templateData?.section3?.description ?? ""}
                      </p>
                    </div>
                    <div class="mt-5">
                      <a class="ct_yellow_btn ct_orange_bg ct_fit_content px-5 mx-auto">
                        View My Profile
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section class=" mt-0 ct_py_100">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h2 class="ct_darksky_blue_text text-center ct_fs_44 ct_fw_600 pb-5">
                  Speakers
                </h2>
              </div>
            </div>
            <div className="text-end mb-4">
              <button
                className="ct_yellow_btn py-2 ct_border_radius_10 ms-auto"
                onClick={handleAddSpeaker}
              >
                + Add Speaker
              </button>
            </div>
            <div class="row ct_px_40  pt-5 justify-content-between">
              {speakerDetails?.map((item, i) => (
                <div class="col-xl-3 col-lg-3 mb-5 ">
                  <div className="position-relative">
                    {speakerDetails?.length > 1 && (
                      <div className="ct_speaker_delete_icon">
                        <i
                          class="fa-solid fa-xmark"
                          onClick={() => handleRemoveSpeaker(i)}
                        ></i>
                      </div>
                    )}
                    <div class="ct_speakers_card">
                      <label class="ct_speaker_img d-block mx-auto">
                        <input
                          className="d-none"
                          accept="image/*"
                          type="file"
                          onChange={(e) => handleImageManage(e, i)}
                        />
                        <img
                          src={
                            speakerImages[i] != ""
                              ? URL.createObjectURL(speakerImages[i])
                              : "/assets/img/meet_nellie_img.png"
                          }
                          alt=""
                        />
                      </label>
                      <div class="ct_about_speaker text-center">
                        <h4
                          class="ct_fs_32 ct_fw_600 mb-2 ct_blue_text"
                          contentEditable="true"
                          onBlur={(e) =>
                            handleChangeSpeakerData(
                              i,
                              "heading",
                              e.target.innerText
                            )
                          }
                        >
                          {item?.heading}
                        </h4>
                        <p
                          class="ct_fs_16"
                          contentEditable="true"
                          onBlur={(e) =>
                            handleChangeSpeakerData(
                              i,
                              "body",
                              e.target.innerText
                            )
                          }
                        >
                          {item?.body}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section
        class="ct_looking_for_work_bg ct_mt_100  ct_p_111_y_106 ct_looking_for_work_bg_left"
        style={{ backgroundColor: "#219EBC" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">
              Built For Founders. Backed by Experience
            </h4>
            <p class="mb-0 ct_fs_18">
              We’ve designed this workshop to deliver clear direction, not just
              inspiration.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
              Reserve Your Spot
            </a>
          </div>
        </div>
      </section>

      <section class="ct_py_100 ct_px_100">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h2
                class="ct_fs_40 ct_darksky_blue_text text-center mb-3 ct_fw_600"
                contentEditable="true"
                onBlur={(e) => handleChangeValue(e, "section4", "heading")}
              >
                {templateData?.section4?.heading ?? ""}
              </h2>
              <p
                class="mb-0 ct_fs_24 text-center mx-auto"
                style={{ maxWidth: "684px" }}
                contentEditable="true"
                onBlur={(e) => handleChangeValue(e, "section4", "body")}
              >
                {templateData?.section4?.body ?? ""}
              </p>
            </div>
          </div>
          <div class="row mt-5 pt-3">
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#F7F7F7" }}
              >
                <div>
                  <h4
                    class="ct_fs_24 mb-2"
                    contentEditable="true"
                    onBlur={(e) =>
                      handleChangeValue(e, "section4", "subHeading1")
                    }
                  >
                    {templateData?.section4?.subHeading1}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    contentEditable="true"
                    onBlur={(e) => handleChangeValue(e, "section4", "subBody1")}
                  >
                    {templateData?.section4?.subBody1}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#EDF6F9" }}
              >
                <div>
                  <h4
                    class="ct_fs_24 mb-2"
                    contentEditable="true"
                    onBlur={(e) =>
                      handleChangeValue(e, "section4", "subHeading3")
                    }
                  >
                    {templateData?.section4?.subHeading3}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    contentEditable="true"
                    onBlur={(e) => handleChangeValue(e, "section4", "subBody3")}
                  >
                    {templateData?.section4?.subBody3}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <label class="ct_learn_img">
                <img src="/assets/img/Rectangle 3.png" alt="" />
              </label>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#ffb80526" }}
              >
                <div>
                  <h4
                    class="ct_fs_24 mb-2"
                    contentEditable="true"
                    onBlur={(e) =>
                      handleChangeValue(e, "section4", "subHeading2")
                    }
                  >
                    {templateData?.section4?.subHeading2}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    contentEditable="true"
                    onBlur={(e) => handleChangeValue(e, "section4", "subBody2")}
                  >
                    {templateData?.section4?.subBody2}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#F5F3EF" }}
              >
                <div>
                  <h4
                    class="ct_fs_24 mb-2"
                    contentEditable="true"
                    onBlur={(e) =>
                      handleChangeValue(e, "section4", "subHeading4")
                    }
                  >
                    {templateData?.section4?.subHeading4}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    contentEditable="true"
                    onBlur={(e) => handleChangeValue(e, "section4", "subBody4")}
                  >
                    {templateData?.section4?.subBody4}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_py_90 ct_light_sky_bg "
        style={{ backgroundColor: "hsl(43deg 100% 51% / 21%)" }}
      >
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <h2
                class="ct_fs_32 mb-3 ct_fw_600 text-center "
                style={{ color: "#FFB703" }}
                contentEditable="true"
                onBlur={(e) => handleChangeValue(e, "section5", "heading")}
              >
                {templateData?.section5?.heading ?? ""}
              </h2>
              <p
                class="mb-0  text-center ct_fs_20"
                contentEditable="true"
                onBlur={(e) => handleChangeValue(e, "section5", "body")}
              >
                {templateData?.section5?.body ?? ""}
              </p>
            </div>
          </div>
          <div class="row ct_pt_60">
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img src="/assets/img/line-md_calendar.png" alt="" />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      Date & Time
                    </h4>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Date: </span>
                      <label>
                        <input
                          type="date"
                          className="border-0 form-control"
                          min={new Date().toISOString().split("T")[0]}
                          value={templateData?.section5?.date}
                          onChange={(e) =>
                            handleChangeValue(
                              e.target.value,
                              "section5",
                              "date"
                            )
                          }
                        />
                      </label>
                    </p>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Time: </span>
                      <label>
                        <input
                          type="time"
                          className="border-0 form-control"
                          value={templateData?.section5?.time}
                          onChange={(e) =>
                            handleChangeValue(
                              e.target.value,
                              "section5",
                              "time"
                            )
                          }
                        />
                      </label>
                    </p>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Duration: </span>
                      <span
                        contentEditable="true"
                        onBlur={(e) =>
                          handleChangeValue(e, "section5", "duration")
                        }
                      >
                        {templateData?.section5?.duration ?? ""}
                      </span>
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img
                      src="/assets/img/locationLogo.png"
                      alt=""
                      style={{ height: "50px" }}
                    />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      Location
                    </h4>
                    <p className="ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap">Format: </span>
                      <span
                        contentEditable="true"
                        onBlur={(e) =>
                          handleChangeValue(e, "section5", "platform")
                        }
                      >
                        {" "}
                        {templateData?.section5?.platform ?? ""}
                      </span>
                    </p>
                    <p className=" ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap">Price: </span> Rs
                      <span
                        contentEditable="true"
                        onBlur={(e) => handleChangeValue(e, "section5", "link")}
                      >
                        {" "}
                        {templateData?.section5?.link ?? ""}{" "}
                      </span>
                    </p>
                    <p className=" ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap">Bonus: </span>
                      <span
                        contentEditable="true"
                        onBlur={(e) =>
                          handleChangeValue(e, "section5", "access")
                        }
                      >
                        {" "}
                        {templateData?.section5?.access ?? ""}
                      </span>
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img src="/assets/img/file.png" alt="" />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      What You’ll Need
                    </h4>
                    <p
                      class="mb-0 ct_fs_18 text-center mx-auto ct_line_h_30"
                      contentEditable="true"
                      onBlur={(e) => handleChangeValue(e, "section5", "body1")}
                    >
                      {templateData?.section5?.body1 ?? ""}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div class="text-center ct_mt_40">
            <button class="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto">
              Reserve Your Spot
            </button>
          </div>
        </div>
      </section>

      <section class=" ct_px_40 pt-0 ct_mt_100">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-7 col-xl-6 col-md-6 mb-4 mb-md-0">
              <div class="ct_about_cnt">
                <h2 class="mb-4 ct_fs_32 mb-5 ">Frequently asked questions</h2>
                {/* <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                    <div class="accordion" id="faq_accordionExample">
                      {templateData?.section6?.faqs?.map((item, i) => (
                        <div className="d-flex align-items-center gap-2">
                          <div class="accordion-item ct_flex_1">
                            <h2
                              class="accordion-header"
                              id="faq_one"
                              contentEditable="true"
                            >
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapsefaq_one${i}`}
                                aria-expanded="false"
                                aria-controls={`collapsefaq_one${i}`}
                              >
                                {item?.question != ""
                                  ? item?.question
                                  : "Enter Question"}
                              </button>
                            </h2>
                            <div
                              id={`collapsefaq_one${i}`}
                              class="accordion-collapse collapse"
                              aria-labelledby="faq_one"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p
                                  class="ct_fs_20 mb-3 ct_line_h_30"
                                  contentEditable="true"
                                >
                                  {item?.answer != ""
                                    ? item?.answer
                                    : "Enter Answer"}
                                </p>
                              </div>
                            </div>
                          </div>
                          {templateData?.section6?.faqs?.length > 1 && (
                            <div className="mt-3 ct_cursor_pointer">
                              <i
                                class="fa-solid fa-trash-can text-danger"
                                onClick={() => handleDeleteFaq(i)}
                              ></i>
                            </div>
                          )}
                        </div>
                      ))}
                      <div className="text-end mt-3">
                        <a
                          className="ct_orange_text ct_fw_600"
                          onClick={handleAddFaq}
                        >
                          + Add FAQ
                        </a>
                      </div>
                    </div>
                  </div> */}
                <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                  <div class="accordion" id="faq_accordionExample">
                    {templateData?.section6?.faqs?.map((item, i) => (
                      <div className="d-flex align-items-center gap-2">
                        <div class="accordion-item ct_flex_1">
                          <h2 class="accordion-header" id={`faq_${i}`}>
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapsefaq_one${i}`}
                              aria-expanded="false"
                              aria-controls={`collapsefaq_one${i}`}
                            >
                              <span
                                contentEditable={"true"}
                                suppressContentEditableWarning
                                onBlur={(e) =>
                                  handleFaqChange(
                                    i,
                                    "question",
                                    e.target.innerText.trim() ||
                                      "Enter Question"
                                  )
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.target.blur();
                                  }
                                }}
                                style={{ outline: "none", width: "100%" }}
                              >
                                {item?.question || "Enter Question"}
                              </span>
                            </button>
                          </h2>
                          <div
                            id={`collapsefaq_one${i}`}
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p
                                class="ct_fs_20 mb-3 ct_line_h_30"
                                contentEditable={"true"}
                                suppressContentEditableWarning
                                onBlur={(e) =>
                                  handleFaqChange(
                                    i,
                                    "answer",
                                    e.target.innerText.trim()
                                  )
                                }
                              >
                                {item?.answer != ""
                                  ? item?.answer
                                  : "Enter Answer"}
                              </p>
                            </div>
                          </div>
                        </div>
                        {templateData?.section6?.faqs?.length > 1 && (
                          <div className="mt-3 ct_cursor_pointer">
                            <i
                              class="fa-solid fa-trash-can text-danger"
                              onClick={() => handleDeleteFaq(i)}
                            ></i>
                          </div>
                        )}
                      </div>
                    ))}
                    <div className="text-end mt-3">
                      <a
                        className="ct_orange_text ct_fw_600"
                        onClick={handleAddFaq}
                      >
                        + Add FAQ
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-4  col-xl-6 col-md-6 mb-4 mb-md-0 ps-md-5">
              {/* <label class="ct_about_img">
                  <img
                    src="/assets/img/faq_6789.png"
                    class="ct_img_h_617"
                    alt=""
                  />
                </label> */}

              <label class="ct_about_img">
                <input
                  className="d-none"
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFaqImage(e)}
                />
                <img
                  src={
                    faqImage != ""
                      ? URL.createObjectURL(faqImage) ??
                        "/assets/img/faq_6789.png"
                      : "/assets/img/faq_6789.png"
                  }
                  alt=""
                  className="ct_img_h_617"
                />
              </label>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_looking_for_work_bg ct_mt_100 ct_p_111_y_106"
        style={{ backgroundColor: "#F58220" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4" style={{ maxWidth: "640px" }}>
              Ready to Join Us Live?
            </h4>
            <p class="mb-0 ct_fs_18" style={{ maxWidth: "619px" }}>
              Spaces are limited reserve your seat and walk away with clarity,
              strategy, and momentum{" "}
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
              View More
            </a>
          </div>
        </div>
      </section>

      {pathname == coachPaths?.AddCoachWorkShop && isSavedAsModal && (
        <SavedAs
          setIsModal={setIsSavedAsModal}
          status={status}
          setSatus={setSatus}
          onSubmit={handleFinalSubmit}
        />
      )}

      <div style={{ height: "100px" }}></div>
      <div className="text-center mb-5">
        <button
          className="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto"
          type="button"
          onClick={handleSubmitForm}
        >
          Submit
        </button>
      </div>
    </CoachMenuLayout>
  );
};

export default CoachAddWorkshopDetails;
